<!--begin::Brand-->
<div class="brand flex-column-auto secondary aside-menu-background" id="sc_brand" [ngClass]="brandClasses">
  <!--begin::Logo-->
  <a routerLink="/" class="brand-logo">
    <img alt="Logo" [attr.src]="headerLogo" width="165px" (click)="buttonClick('AsideLogo')" />
  </a>
  <!--end::Logo-->

  @if (asideSelfMinimizeToggle) {
    <div>
      <button class="sc-aside-menu-minimize btn btn-sm px-0 brand-toggle" (click)="toggleAside()">
        <span class="svg-icon svg-icon svg-icon-xl">
          <!--begin::Svg Icon | path:assets/media/svg/icons/Navigation/Angle-double-left.svg--><svg
          xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px"
          viewBox="0 0 24 24" version="1.1">
          <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <polygon points="0 0 24 0 24 24 0 24" />
            <path
              d="M5.29288961,6.70710318 C4.90236532,6.31657888 4.90236532,5.68341391 5.29288961,5.29288961 C5.68341391,4.90236532 6.31657888,4.90236532 6.70710318,5.29288961 L12.7071032,11.2928896 C13.0856821,11.6714686 13.0989277,12.281055 12.7371505,12.675721 L7.23715054,18.675721 C6.86395813,19.08284 6.23139076,19.1103429 5.82427177,18.7371505 C5.41715278,18.3639581 5.38964985,17.7313908 5.76284226,17.3242718 L10.6158586,12.0300721 L5.29288961,6.70710318 Z"
              fill="#000000" fill-rule="nonzero"
              transform="translate(8.999997, 11.999999) scale(-1, 1) translate(-8.999997, -11.999999) " />
              <path
                d="M10.7071009,15.7071068 C10.3165766,16.0976311 9.68341162,16.0976311 9.29288733,15.7071068 C8.90236304,15.3165825 8.90236304,14.6834175 9.29288733,14.2928932 L15.2928873,8.29289322 C15.6714663,7.91431428 16.2810527,7.90106866 16.6757187,8.26284586 L22.6757187,13.7628459 C23.0828377,14.1360383 23.1103407,14.7686056 22.7371482,15.1757246 C22.3639558,15.5828436 21.7313885,15.6103465 21.3242695,15.2371541 L16.0300699,10.3841378 L10.7071009,15.7071068 Z"
                fill="#000000" fill-rule="nonzero" opacity="0.3"
                transform="translate(15.999997, 11.999999) scale(-1, 1) rotate(-270.000000) translate(-15.999997, -11.999999) " />
              </g>
            </svg>
            <!--end::Svg Icon-->
          </span>
        </button>
      </div>
    }
  </div>

  <!--end::Brand-->
  <!--begin::Aside Menu-->
  <div class="aside-menu-wrapper flex-column-fluid aside-menu-background" id="sc_aside_menu_wrapper">
    @if (disableAsideSelfDisplay) {
      <!--begin::Header Logo-->
      <a routerLink="/">
        <img alt="Logo" [attr.src]="poweredByLogo" />
      </a>
      <!--end::Header Logo-->
    }
    <!--begin::Menu Container-->
    @if (menuConfig && menuConfig.items) {
      <div id="sc_aside_menu" class="aside-menu aside-menu-background" [ngClass]="asideMenuCSSClasses" data-menu-vertical="1"
        [attr.data-menu-scroll]="asideMenuScroll" [attr.data-menu-dropdown]="asideMenuDropdown"
        data-menu-dropdown-timeout="500">
        <!-- begin::Menu Nav -->
        <ul class="menu-nav" [ngClass]="ulCSSClasses">
          @for (item of menuConfig.items; track item) {
            @if (item.section) {
              <ng-container [ngTemplateOutlet]="menuItemSectionTemplate" [ngTemplateOutletContext]="{ item: item }"></ng-container>
            }
            @if (item.separator) {
              <ng-container [ngTemplateOutlet]="menuItemSeparatorTemplate"></ng-container>
            }
            @if (item.title) {
              <ng-container [ngTemplateOutlet]="menu1LevelTemplate" [ngTemplateOutletContext]="{ item: item }"></ng-container>
            }
          }
        </ul>
        <!-- end::Menu Nav -->
      </div>
      <!--end::Menu Container-->
    }
    <div id="sc_aside_menu" class="aside-menu aside-menu-background" [ngClass]="asideMenuCSSClasses" data-menu-vertical="1"
      [attr.data-menu-scroll]="asideMenuScroll" [attr.data-menu-dropdown]="asideMenuDropdown"
      data-menu-dropdown-timeout="500">
      <ul class="menu-nav" [ngClass]="ulCSSClasses">
        <li class="menu-item menu-item-height" (click)="getTipsButton()">
          <button class="btn menu-link menu-item-height position-relative">
            <svg class="menu-icon menu-icon-bg" viewBox="0 0 24 24" fill="none">
              <g clip-path="url(#clip0_1045_40)">
                <path d="M22.8955 0C23.5053 0 24 0.494666 24 1.10449V17.5293C23.9998 18.139 23.5052 18.6328 22.8955 18.6328H15.998C15.8433 18.6328 15.7148 18.7485 15.627 18.876L12.2891 23.7168C12.0285 24.0945 11.4706 24.0943 11.21 23.7168L7.87109 18.876C7.78323 18.7486 7.65573 18.6329 7.50098 18.6328H1.10449C0.494774 18.6328 0.00017417 18.139 0 17.5293V1.10449C0 0.494666 0.494666 0 1.10449 0H22.8955ZM11.9531 2.5C8.11313 2.5 5 5.61313 5 9.45312C5.00011 13.293 8.11319 16.4062 11.9531 16.4062C15.793 16.4061 18.9061 13.293 18.9062 9.45312C18.9062 5.61319 15.793 2.50011 11.9531 2.5Z"/>
                <path d="M12.8605 14.2038C13.087 13.9765 13.2142 13.6682 13.2142 13.3468C13.2142 13.0253 13.087 12.7171 12.8605 12.4898C12.634 12.2625 12.3268 12.1348 12.0065 12.1348C11.6862 12.1348 11.379 12.2625 11.1526 12.4898C10.9261 12.7171 10.7988 13.0253 10.7988 13.3468C10.7988 13.6682 10.9261 13.9765 11.1526 14.2038C11.379 14.4311 11.6862 14.5588 12.0065 14.5588C12.3268 14.5588 12.634 14.4311 12.8605 14.2038Z" />
                <path d="M12.0065 4C11.031 4 10.2649 4.79308 10.3577 5.70818L11.0125 10.7717C11.0323 11.0026 11.1453 11.2184 11.3293 11.3765C11.5133 11.5345 11.7548 11.6235 12.0065 11.6258C12.2581 11.6235 12.4997 11.5345 12.6836 11.3765C12.8676 11.2184 12.9806 11.0026 13.0005 10.7717L13.6552 5.70818C13.7467 4.79186 12.9819 4 12.0065 4Z"/>
              </g>
            </svg>
            <span class="menu-text justify-content-center">
              Get Tips
            </span>
          </button>
        </li>
      </ul>
    </div>
    <div class="divider">
      <span></span>
      <span class="menu-text">v. {{getAppVersion()}}</span>
      <span></span>
    </div>

    <!--begin::Powered By Logo-->
    <div class="bottom">
      <div class="brand-bottom">
        <img [alt]="branding.COMPANY_NAME + 'Logo'" class="brand-logo" [attr.src]="poweredByLogo" width="150px" />
      </div>
    </div>
    <!--end::Powered By Logo-->
  </div>
  <!--end::Aside Menu-->

  <!-- begin::1 Level -->
  <ng-template #menu1LevelTemplate let-item="item">
    <!-- begin::if don't have submenu -->
    @if (!item.submenu && hasPermission(item.permission)) {
      <li class="menu-item menu-item-height" aria-haspopup="true" routerLinkActive="menu-item-active">
        <a class="menu-link menu-item-height" [routerLink]="item.page" routerLinkActive="active" (click)="buttonClick(item.title)">
          <span class="svg-icon menu-icon">
            <svg class="svg-icon menu-icon svg-responsive" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
              [innerHTML]="item.icon | SafeHTML">
            </svg>
          </span>
          <span class="menu-text" [translate]="item.translate">
            {{ item.title }}
          </span>
        </a>
      </li>
    }
    <!-- end::if don't have submenu -->
    <!-- begin::if has submenu -->
    @if (item.submenu) {
      <li class="menu-item menu-item-submenu" data-menu-toggle="hover"
        [ngClass]="{ 'menu-item-open': isMenuItemActive(item.page) }" routerLinkActive="menu-item-open">
        <a class="menu-link menu-toggle" aria-haspopup="true" [attr.href]="item.page" routerLinkActive="active"
          [ngClass]="{ 'active ': isMenuItemActive(item.page) }">
          <span class="svg-icon menu-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"
              [innerHTML]="item.icon | SafeHTML">
            </svg>
          </span>
          <span class="menu-text" [translate]="item.translate">
            {{
            item.title
            }}
          </span>
          <i class="menu-arrow"></i>
        </a>
        <div class="menu-submenu">
          <i class="menu-arrow"></i>
          <ul class="menu-subnav">
            <li class="menu-item menu-item-parent">
              <a class="menu-link" aria-haspopup="true">
                <span class="menu-text" [translate]="item.translate">
                  {{ item.title }}
                </span>
              </a>
            </li>
            @for (sub of item.submenu; track sub) {
              <ng-container [ngTemplateOutlet]="menu2LevelTemplate"
              [ngTemplateOutletContext]="{ item: sub }"></ng-container>
            }
          </ul>
        </div>
      </li>
    }
    <!-- end::if has submenu -->
  </ng-template>
  <!-- end::1 Level -->
  <!-- begin::2 Level -->
  <ng-template #menu2LevelTemplate let-item="item">
    <!-- begin::if don't have submenu -->
    @if (!item.submenu) {
      <li class="menu-item" routerLinkActive="menu-item-active" data-menu-toggle="hover">
        <a class="menu-link" aria-haspopup="true" [routerLink]="item.page" routerLinkActive="active">
          <i class="menu-bullet menu-bullet-dot">
            <span></span>
          </i>
          <span class="menu-text" [translate]="item.translate">
            {{ item.title }}
          </span>
        </a>
      </li>
    }
    <!-- end::if don't have submenu -->
    <!-- begin::if has submenu -->
    @if (item.submenu) {
      <li class="menu-item menu-item-submenu" data-menu-toggle="hover"
        [ngClass]="{ 'menu-item-open': isMenuItemActive(item.page) }" routerLinkActive="menu-item-open">
        <a class="menu-link menu-toggle" aria-haspopup="true" [attr.href]="item.page" [ngClass]="{ 'active ': isMenuItemActive(item.page) }"
          routerLinkActive="active">
          <i class="menu-bullet menu-bullet-dot">
            <span></span>
          </i>
          <span class="menu-text" [translate]="item.translate">
            {{ item.title }}
          </span>
          <i class="menu-arrow"></i>
        </a>
        <div class="menu-submenu">
          <i class="menu-arrow"></i>
          <ul class="menu-subnav">
            <!-- submenu-->
            @for (sub of item.submenu; track sub) {
              <ng-container [ngTemplateOutlet]="menu3LevelTemplate"
              [ngTemplateOutletContext]="{ item: sub }"></ng-container>
            }
          </ul>
        </div>
      </li>
    }
    <!-- end::if has submenu -->
  </ng-template>
  <!-- end::2 Level -->
  <!-- begin::3 Level -->
  <ng-template #menu3LevelTemplate let-item="item">
    <li class="menu-item" routerLinkActive="menu-item-active">
      <a class="menu-link" aria-haspopup="true" [routerLink]="item.page" routerLinkActive="active">
        <i class="menu-bullet menu-bullet-dot">
          <span></span>
        </i>
        <span class="menu-text" [translate]="item.translate">
          {{ item.title }}
        </span>
      </a>
    </li>
  </ng-template>
  <!-- end::3 Level -->
  <!-- begin::Separator -->
  <ng-template #menuItemSeparatorTemplate>
    <li class="menu-separator"><span></span></li>
  </ng-template>
  <!-- end::3 Separator -->
  <!-- begin::Section -->
  <ng-template #menuItemSectionTemplate let-item="item">
    @if (item.permission == '' || (hasPermission(item.permission) && (hasPermission('Pages.Administration.Users') || hasPermission('Pages.Administration.Roles') || hasPermission('Pages.Administration.PropertyGroups')))) {
      <li class="menu-section m-0">
        <h4 class="menu-text" [translate]="item.translate">{{ item.section }}</h4>
        <i class="menu-icon flaticon-more-v2"></i>
      </li>
    }
  </ng-template>
  <!-- end::Section -->